'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

exports.default = createApiClient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function absoluteUrl(path, config, language) {
  if (__SERVER__) return 'http://' + config.host + ':' + config.port + '/' + language + '/store/api' + path;
  return '/' + language + '/store/api' + path;
}

function requestOptions(options, config) {
  options.mode = 'cors';
  options.credentials = 'same-origin';
  options.headers = {};

  var cookie = __SERVER__ ? config.req && config.req.headers && config.req.headers.cookie : document && document.cookie;

  if (cookie) options.headers.Cookie = cookie;

  return options;
}

function requestQuery(query, url) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      req = _ref.req;

  if (!query.locale) {
    query.locale = req && req.language || window && window.__locale;
  }

  if (__CLIENT__) {
    query.originalUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    query.referer = window.referrer;
  }

  if (__SERVER__) {
    query.originalUrl = 'https://' + req.get('host') + req.originalUrl;
    query.originalHostname = req.hostname;
    query.referer = req.get('Referer') || '';
    query.remoteAddress = (req.headers['x-forwarded-for'] || '').split(',')[0] || req.connection.remoteAddress;
  }

  return query;
}

function makeRequest(apiRequest, url, method, query, config) {
  var lng = config.req && config.req.language || window && window.__locale;

  return apiRequest[method](requestQuery(query, url(lng), config));
}

var ApiClient = (_temp = _class = function ApiClient(path, options, config) {
  var _this = this;

  (0, _classCallCheck3.default)(this, ApiClient);

  var url = function url(locale) {
    return absoluteUrl(path, config, locale.split('-').shift());
  };

  var apiRequest = function apiRequest(opts) {
    var reqConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var locale = reqConfig.req && reqConfig.req.language || window && window.__locale;

    return fetchival(url(locale), requestOptions(options, config));
  };

  ApiClient.methods.forEach(function (method) {
    _this[method] = function () {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return makeRequest(apiRequest(opts, config), url, method, opts, config);
    };
  });
}, _class.methods = ['get', 'post', 'put', 'patch', 'delete'], _temp);
function createApiClient() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function (path) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new ApiClient(path, options, config);
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/createApiClient.js
// module id = 124
// module chunks = 0